'use client';

import { useDomain } from '@/hooks/useDomain'

export default function Header() {
  const { domain } = useDomain()

  return (
    <header className="bg-blue-800 text-white py-4">
      <div className="container mx-auto px-4">
        <h1 className="text-2xl font-bold">{domain}</h1>
      </div>
    </header>
  )
} 